import {
  Button,
  DatePicker,
  Input,
  Layout,
  Pagination,
  Popover,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";

import { FaFilter, FaPlus, FaSearch, FaUsers } from "react-icons/fa";
import { useNavigate } from "react-router";
import Card from "../../components/card";

import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Get } from "../../config/api/get";
import { COMMUNITY } from "../../config/constants/api";
import { ImageUrl } from "../../helpers/Functions";
import "../course-management/course-management.css";
import "./community.css";

export default function Community() {
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const [allPost, setAllPost] = useState([]);
  const [open, setOpen] = useState(false);

  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 14,
    totalDocs: 0,
    totalPages: 0,
  });

  const getPosts = async (pageNumber, pageSize, search, reset = false) => {
    try {
      const response = await Get(COMMUNITY.getAllPost, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        type: reset ? "" : filter.type || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });

      setLoading(false);

      if (response.status === true) {
        setAllPost(response?.data);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        console.log("error====>", response);
      }
    } catch (error) {
      setLoading(false);
      swal("Error", error?.message || "something went wrong", "error");
      console.log(error);
    }
  };

  useEffect(() => {
    getPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message =
    paginationConfig.totalDocs > 0
      ? `Showing records ${startIndex} to ${endIndex} of ${paginationConfig.totalDocs}`
      : "Showing records 0 of 0";

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getPosts(pageNumber);
  };

  const handleSearch = (nextValue) => {
    setFilter({
      ...filter,
      keyword: nextValue,
    });
  };

  const handleStatusChange = (nextValue) => {
    setFilter({
      ...filter,
      status: nextValue,
    });
  };

  const handleTypeChange = (nextValue) => {
    setFilter({
      ...filter,
      type: nextValue,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getPosts(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const runHeroSearch = () => {
    const keyword = value.trim();
    setFilter((prev) => ({ ...prev, keyword }));
    getPosts(1, paginationConfig.limit, keyword || null);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="community-pagination-custom-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="community-pagination-custom-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const filterContent = (
    <div className="filterDropdown community-filter-popover">
      <div>
        <p className="mainLabel" style={{ padding: "10px" }}>
          Filter
        </p>
      </div>
      <hr style={{ margin: 0 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">Lesson Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          placeholder="From"
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          placeholder="To"
        />

        <p className="mainLabel">Lesson Type:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Lesson Type"
          value={filter.type}
          onChange={(e) => handleTypeChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "TUTORING", label: "Training" },
            { value: "COACHING", label: "Consulting" },
          ]}
        />

        <p className="mainLabel">Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "UPCOMING", label: "Upcoming" },
          ]}
        />

        <Button
          type="primary"
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="loginButton"
          onClick={() => {
            getPosts();
          }}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout className="cm-page community-page">
      <section
        className="cm-hero"
        style={{
          backgroundImage: `url(${ImageUrl("community-bnr.png")})`,
        }}
      >
        <div className="cm-hero-overlay" aria-hidden />
        <div className="cm-wrap cm-hero-inner">
          <div className="cm-hero-copy">
            <span className="cm-hero-badge">COMMUNITY</span>
            <h1 className="fontFamily1 cm-hero-title">
              Find Your <span>Community.</span>
            </h1>
            <p className="fontFamily1 cm-hero-sub">
              Connect, collaborate and grow together. From education and
              learning to real conversations, there&apos;s a place for you.
            </p>

            <div className="community-hero-search">
              <input
                type="text"
                placeholder="Explore discussion, topics or communities..."
                className="community-hero-search-input"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    runHeroSearch();
                  }
                }}
                aria-label="Search communities"
              />
              <button
                type="button"
                className="community-hero-search-btn"
                onClick={runHeroSearch}
                aria-label="Search"
              >
                <FaSearch />
              </button>
            </div>
          </div>
        </div>
      </section>

      <div className="cm-wrap cm-main">
        <div className="cm-panel">
          <div className="cm-toolbar">
            <div className="cm-toolbar-intro">
              <span className="cm-toolbar-icon" aria-hidden>
                <FaUsers />
              </span>
              <h2 className="fontFamily1">Communities</h2>
            </div>
          </div>

          <div className="cm-sub-toolbar">
            <div className="cm-search-row" style={{ marginLeft: "auto" }}>
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button className="cm-filter-trigger" aria-label="Open filters">
                  <FaFilter />
                </Button>
              </Popover>
              <div className="cm-search-wrap">
                <Input
                  className="cm-search"
                  placeholder="Search communities..."
                  value={filter.keyword}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={() =>
                    getPosts(1, paginationConfig.limit, filter.keyword)
                  }
                />
                <button
                  type="button"
                  className="cm-search-btn"
                  aria-label="Search communities"
                  onClick={() =>
                    getPosts(1, paginationConfig.limit, filter.keyword)
                  }
                >
                  <FaSearch />
                </button>
              </div>
            </div>
          </div>

          <div className="community-grid">
            {loading ? (
              <div className="community-loading">
                <p className="community-loading-text">Loading</p>
                <div className="community-loading-spinner" aria-hidden="true" />
              </div>
            ) : (
              <>
                <article
                  className="community-post-card community-post-card--add"
                  onClick={() => navigate("/create-form")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      navigate("/create-form");
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <div className="community-add-card-inner">
                    <div className="community-add-card-icon">
                      <FaPlus size={28} color="#fff" />
                    </div>
                    <h3 className="community-add-card-title">Add New</h3>
                    <p className="community-add-card-subtitle">
                      Start a new post and connect with your community.
                    </p>
                  </div>
                </article>

                {allPost?.docs?.map((post, i) => (
                  <Card post={post} key={post?._id || i} />
                ))}
              </>
            )}
          </div>

          <div className="cm-pagination-row">
            <p className="fontFamily1 cm-pagination-meta">{message}</p>
            <Pagination
              className="styledPagination cm-pagination"
              showSizeChanger={false}
              onChange={(page) => handlePageChange(page)}
              current={parseInt(paginationConfig.pageNumber, 10)}
              pageSize={paginationConfig.limit}
              total={paginationConfig.totalDocs}
              itemRender={itemRender}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
